import { render, staticRenderFns } from "./StudentStatistics.vue?vue&type=template&id=489475f4&scoped=true"
import script from "./StudentStatistics.vue?vue&type=script&lang=js"
export * from "./StudentStatistics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "489475f4",
  null
  
)

export default component.exports